import { useState } from "react";

export default function SignUp({ onSwitch, login }) {
  const [form, setForm] = useState({ name: "", email: "", password: "", confirm: "", role: "Analyst" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setError("");
    if (form.password !== form.confirm) { setError("Passwords do not match!"); return; }
    if (form.password.length < 6) { setError("Password must be at least 6 characters."); return; }
    setLoading(true);
    setTimeout(() => {
      const user = {
        name: form.name,
        email: form.email,
        role: form.role,
        avatar: form.name.split(" ").map(n => n[0]).join("").toUpperCase().slice(0, 2),
      };
      setSuccess(true);
      setTimeout(() => login(user), 1200);
      setLoading(false);
    }, 1000);
  };

  return (
    <div style={styles.bg}>
      <div style={styles.grid} />
      <div style={styles.blob1} />
      <div style={styles.blob2} />
      <div style={styles.card}>
        <div style={styles.logoRow}>
          <div style={styles.logoIcon}>
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <polyline points="22 12 18 12 15 21 9 3 6 12 2 12" />
            </svg>
          </div>
          <span style={styles.logoText}>InsightForge</span>
        </div>

        {success ? (
          <div style={{ textAlign: "center", padding: "20px 0" }}>
            <div style={{ fontSize: 56, marginBottom: 16 }}>🎉</div>
            <h2 style={{ color: "#6EE7B7", fontSize: 22, fontWeight: 800, marginBottom: 8 }}>Account Created!</h2>
            <p style={{ color: "#8892a4", fontSize: 14 }}>Redirecting to dashboard...</p>
          </div>
        ) : (
          <>
            <h1 style={styles.title}>Create Account</h1>
            <p style={styles.sub}>Join InsightForge today — it's free</p>
            <form onSubmit={handleSubmit} style={{ width: "100%" }}>
              <div style={styles.field}>
                <label style={styles.label}>Full Name</label>
                <div style={styles.inputWrap}>
                  <svg style={styles.inputIcon} width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#8892a4" strokeWidth="2"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" /><circle cx="12" cy="7" r="4" /></svg>
                  <input style={styles.input} type="text" placeholder="James Doe"
                    value={form.name} onChange={e => setForm({ ...form, name: e.target.value })}
                    onFocus={e => { e.target.parentNode.style.borderColor = "rgba(110,231,183,0.5)"; e.target.parentNode.style.boxShadow = "0 0 0 3px rgba(110,231,183,0.08)"; }}
                    onBlur={e => { e.target.parentNode.style.borderColor = "rgba(255,255,255,0.1)"; e.target.parentNode.style.boxShadow = "none"; }}
                    required />
                </div>
              </div>
              <div style={styles.field}>
                <label style={styles.label}>Email Address</label>
                <div style={styles.inputWrap}>
                  <svg style={styles.inputIcon} width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#8892a4" strokeWidth="2"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" /><polyline points="22,6 12,13 2,6" /></svg>
                  <input style={styles.input} type="email" placeholder="you@example.com"
                    value={form.email} onChange={e => setForm({ ...form, email: e.target.value })}
                    onFocus={e => { e.target.parentNode.style.borderColor = "rgba(110,231,183,0.5)"; e.target.parentNode.style.boxShadow = "0 0 0 3px rgba(110,231,183,0.08)"; }}
                    onBlur={e => { e.target.parentNode.style.borderColor = "rgba(255,255,255,0.1)"; e.target.parentNode.style.boxShadow = "none"; }}
                    required />
                </div>
              </div>
              <div style={styles.field}>
                <label style={styles.label}>Role</label>
                <select style={{ ...styles.input, padding: "13px 14px", background: "rgba(255,255,255,0.04)", border: "1px solid rgba(255,255,255,0.1)", borderRadius: 12, color: "#E8EDF5", width: "100%", cursor: "pointer" }}
                  value={form.role} onChange={e => setForm({ ...form, role: e.target.value })}>
                  <option value="Analyst" style={{ background: "#0A0E17" }}>Analyst</option>
                  <option value="Manager" style={{ background: "#0A0E17" }}>Manager</option>
                  <option value="Developer" style={{ background: "#0A0E17" }}>Developer</option>
                  <option value="Admin" style={{ background: "#0A0E17" }}>Admin</option>
                </select>
              </div>
              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
                <div style={styles.field}>
                  <label style={styles.label}>Password</label>
                  <div style={styles.inputWrap}>
                    <svg style={styles.inputIcon} width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#8892a4" strokeWidth="2"><rect x="3" y="11" width="18" height="11" rx="2" ry="2" /><path d="M7 11V7a5 5 0 0 1 10 0v4" /></svg>
                    <input style={styles.input} type="password" placeholder="••••••"
                      value={form.password} onChange={e => setForm({ ...form, password: e.target.value })}
                      onFocus={e => { e.target.parentNode.style.borderColor = "rgba(110,231,183,0.5)"; }}
                      onBlur={e => { e.target.parentNode.style.borderColor = "rgba(255,255,255,0.1)"; }}
                      required />
                  </div>
                </div>
                <div style={styles.field}>
                  <label style={styles.label}>Confirm</label>
                  <div style={styles.inputWrap}>
                    <svg style={styles.inputIcon} width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#8892a4" strokeWidth="2"><rect x="3" y="11" width="18" height="11" rx="2" ry="2" /><path d="M7 11V7a5 5 0 0 1 10 0v4" /></svg>
                    <input style={styles.input} type="password" placeholder="••••••"
                      value={form.confirm} onChange={e => setForm({ ...form, confirm: e.target.value })}
                      onFocus={e => { e.target.parentNode.style.borderColor = "rgba(110,231,183,0.5)"; }}
                      onBlur={e => { e.target.parentNode.style.borderColor = "rgba(255,255,255,0.1)"; }}
                      required />
                  </div>
                </div>
              </div>
              {/* Password strength */}
              {form.password && (
                <div style={{ marginBottom: 16 }}>
                  <div style={{ display: "flex", gap: 4, marginBottom: 4 }}>
                    {[1,2,3,4].map(i => (
                      <div key={i} style={{ flex: 1, height: 3, borderRadius: 2, background: i <= (form.password.length < 6 ? 1 : form.password.length < 8 ? 2 : form.password.length < 10 ? 3 : 4) ? (form.password.length < 6 ? "#F87171" : form.password.length < 8 ? "#FBBF24" : form.password.length < 10 ? "#60A5FA" : "#6EE7B7") : "rgba(255,255,255,0.1)" }} />
                    ))}
                  </div>
                  <span style={{ fontSize: 11, color: form.password.length < 6 ? "#F87171" : form.password.length < 8 ? "#FBBF24" : form.password.length < 10 ? "#60A5FA" : "#6EE7B7" }}>
                    {form.password.length < 6 ? "Weak" : form.password.length < 8 ? "Fair" : form.password.length < 10 ? "Good" : "Strong"}
                  </span>
                </div>
              )}
              {error && <div style={styles.error}>{error}</div>}
              <button type="submit" disabled={loading} style={{ ...styles.btn, opacity: loading ? 0.7 : 1 }}
                onMouseEnter={e => { if (!loading) { e.currentTarget.style.transform = "translateY(-2px)"; e.currentTarget.style.boxShadow = "0 12px 30px rgba(110,231,183,0.4)"; }}}
                onMouseLeave={e => { e.currentTarget.style.transform = "none"; e.currentTarget.style.boxShadow = "0 4px 15px rgba(110,231,183,0.2)"; }}>
                {loading ? "Creating account..." : "Create Account →"}
              </button>
            </form>
            <p style={{ textAlign: "center", marginTop: 20, fontSize: 14, color: "#8892a4" }}>
              Already have an account?{" "}
              <span onClick={onSwitch} style={{ color: "#6EE7B7", cursor: "pointer", fontWeight: 600 }}>Sign in</span>
            </p>
          </>
        )}
      </div>
    </div>
  );
}

const styles = {
  bg: { minHeight: "100vh", background: "#0A0E17", display: "flex", alignItems: "center", justifyContent: "center", position: "relative", overflow: "hidden", padding: 20 },
  grid: { position: "fixed", inset: 0, backgroundImage: "linear-gradient(rgba(110,231,183,0.03) 1px, transparent 1px), linear-gradient(90deg, rgba(110,231,183,0.03) 1px, transparent 1px)", backgroundSize: "40px 40px", pointerEvents: "none" },
  blob1: { position: "fixed", top: "-20%", right: "-10%", width: 500, height: 500, borderRadius: "50%", background: "radial-gradient(circle, rgba(167,139,250,0.08) 0%, transparent 70%)", pointerEvents: "none" },
  blob2: { position: "fixed", bottom: "-20%", left: "-10%", width: 400, height: 400, borderRadius: "50%", background: "radial-gradient(circle, rgba(110,231,183,0.08) 0%, transparent 70%)", pointerEvents: "none" },
  card: { background: "rgba(255,255,255,0.03)", border: "1px solid rgba(255,255,255,0.08)", borderRadius: 20, padding: "40px 36px", width: "100%", maxWidth: 480, backdropFilter: "blur(20px)", boxShadow: "0 30px 80px rgba(0,0,0,0.5)", position: "relative", zIndex: 1, display: "flex", flexDirection: "column", alignItems: "center" },
  logoRow: { display: "flex", alignItems: "center", gap: 10, marginBottom: 28 },
  logoIcon: { width: 40, height: 40, borderRadius: 12, background: "linear-gradient(135deg, #6EE7B7, #60A5FA)", display: "flex", alignItems: "center", justifyContent: "center" },
  logoText: { fontSize: 22, fontWeight: 800, color: "#E8EDF5", letterSpacing: "-0.02em" },
  title: { fontSize: 24, fontWeight: 800, color: "#E8EDF5", marginBottom: 8, textAlign: "center" },
  sub: { fontSize: 14, color: "#8892a4", marginBottom: 24, textAlign: "center" },
  field: { marginBottom: 16, width: "100%" },
  label: { display: "block", fontSize: 13, fontWeight: 600, color: "#C8D0DC", marginBottom: 8 },
  inputWrap: { position: "relative", display: "flex", alignItems: "center", background: "rgba(255,255,255,0.04)", border: "1px solid rgba(255,255,255,0.1)", borderRadius: 12, transition: "all 0.2s ease" },
  inputIcon: { position: "absolute", left: 14, pointerEvents: "none" },
  input: { width: "100%", background: "none", border: "none", outline: "none", color: "#E8EDF5", fontSize: 14, padding: "13px 14px 13px 42px", fontFamily: "inherit" },
  error: { background: "rgba(248,113,113,0.1)", border: "1px solid rgba(248,113,113,0.2)", borderRadius: 10, padding: "10px 14px", color: "#F87171", fontSize: 13, marginBottom: 16, textAlign: "center" },
  btn: { width: "100%", padding: "14px", borderRadius: 12, background: "linear-gradient(135deg, #6EE7B7, #34D399)", border: "none", color: "#0A0E17", fontSize: 15, fontWeight: 800, cursor: "pointer", transition: "all 0.2s ease", boxShadow: "0 4px 15px rgba(110,231,183,0.2)" },
};